import './_the-title.scss';
import {CharacterReveal, MultilineReveal} from "react-text-reveal";
import {useEffect, useRef, useState} from "react";
export default function TheTitle() {

    const [textPlay, setTextPlay] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setTextPlay(true)
        }, 100);
    }, []);

    let textLines = matchMedia('(max-aspect-ratio: 3/4)').matches
        ? [ "Wybierz i otwórz swoje pudełko! W każdym pudełku ",
            "czeka na Ciebie wyjątkowy prezent - autorska kartka",
            "świąteczna przygotowana przez naszych projektantów!",
            "",
            "Wesołych świąt!"]

        : [ "Wybierz i otwórz swoje pudełko!",
            "W każdym pudełku czeka na Ciebie wyjątkowy",
            "prezent - autorska kartka świąteczna",
            "przygotowana przez naszych projektantów!",
            "",
            "Wesołych świąt!"]

    return <div className='the-title'>
        <img src='./assets/img/swiateczny.png' id="swiateczny" alt="Świąteczny" />
        <img src='./assets/img/unboxing.png' id="unboxing" alt="unboxing" />
        <img src='./assets/img/opusb.png' id="opusb" alt="Opus B" />

        <div className='wishes'>
            {/* https://github.com/Swanson-Tyler/react-text-reveal?tab=readme-ov-file */}
            <MultilineReveal
                animateOpacity={true}
                canPlay={textPlay}
                copy={textLines}
                direction={"bottom"}
                duration={500} // ms
                ease={"cubic-bezier(0,0.4,0.4,1)"}
                offset={"20px"}
                wordOffsetDelay={200}
                multilineMasking={false}
                multilineOffsetDelay={200} // ms
            />
        </div>

    </div>
}
